// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3LNZl","legacyBtn":"MutateMid_legacyBtn__3jeHk"};